import React, { Component } from 'react'
import { View } from 'react-native'

import { Text } from '../../Atoms/Typography'
import TranslatedText from '../../Atoms/TranslatedText'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import ValueChangeText from '../../Molecules/ValueChangeText'
import ROEItem from '../../Organisms/ROEItem'
import LoadAfterDelay from '../../Hocs/LoadAfterDelay'
import { thousandSeparator, percentage } from '../../../lib/formatters'
import { TableHeader, TableSection, Column, borderHack } from './Table'

import styled from 'styled-components/native'
import { lighten } from 'polished'
import theme from '../../../styles/theme'

import { translate } from '../../../services/translate'

const { gutterUnit } = theme

const Container = styled(View)`
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
`

const Table = styled(View)`
  flex: 8;
`
const Row = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${props => props.height}px;
  width: 100%;
`

export const Column1 = styled(Column)`
  width: 60%;
  height: 100%;
  justify-content: flex-start;
`

export const Column2 = styled(Column)`
  width: 20%;
  justify-content: flex-end;
  background-color: ${lighten(0.4, theme.colours.orange)};
  padding-right: ${5 * gutterUnit}px;
  height: 100%;
`

export const Column3 = styled(Column)`
  width: 20%;
  height: 100%;
`

const WidgetArea = styled(View)`
  flex: 2;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

const WidgetHeader = styled(View)`
  background-color: ${theme.colours.darkBlue};
  borderBottomColor: ${theme.colours.bordergrey};
  borderBottomWidth: 1px;
  width: 100%;
`

const ROEItemContainer = styled(View)`
  flex: 1;
  height: 25%;
  width: 100%;
  padding: ${theme.gutterUnit / 2}px ${2 * theme.gutterUnit}px;
`

const formatValue = (val) => {
  if (val === 0) {
    return '-'
  }
  if (val < 0) {
    return `(${thousandSeparator(val * -1)})`
  }
  return thousandSeparator(val)
}

const formatPercentage = (val) => {
  if (val === 0) {
    return '-'
  }
  return percentage(val)
}

const heightForNumberOfRows = {
  20: 32,
  19: 33.8,
  18: 35.7,
  17: 37.6
}

class FinancialGroupProfitAndLoss extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.loaded && !this.props.loaded) {
      return true
    }
    if (!nextProps.active) {
      return false
    }
    return true
  }

  render = () => {
    const { data, divisions, round, denomination, fundsMgmtIncomeEnabled, investmentExperienceEnabled, specialProjectsEnabled, loaded } = this.props
    const numOfRows = 20 - !fundsMgmtIncomeEnabled - !investmentExperienceEnabled - !specialProjectsEnabled
    const rowHeight = heightForNumberOfRows[numOfRows]
    return (
      <Container>
        <Table>
          <TableHeader>
            <Row height={rowHeight}>
              <Column1><TranslatedText size='s' bold white uppercase value='ourFinancials.groupProfitLoss.screenHeader' default='GROUP PROFIT & LOSS' /></Column1>
              <Column2 style={{ backgroundColor: 'transparent' }} />
              <Column3 />
            </Row>
            <Row height={rowHeight}>
              <Column1><Text size='s' medium white>{denomination}</Text></Column1>
              <Column2 style={{ backgroundColor: 'transparent' }}><Text size='s' medium white uppercase>{`${translate('general.year', 'YEAR')} ${round - 1}`}</Text></Column2>
              <Column3><TranslatedText size='s' medium white uppercase value='general.change' default='CHANGE' /></Column3>
            </Row>
          </TableHeader>
          {loaded ? (
            <>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.interestIncome' default='Interest Income' /></Column1>
                  <Column2><Text>{formatValue(data.interestIncome)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.interestIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.interestExpense' default='Interest Expense' /></Column1>
                  <Column2><Text>{formatValue(data.interestExpense)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.interestExpenseChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                </Row>
              </TableSection>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.netInterestIncome' default='Net Interest Income' /></Column1>
                  <Column2><Text>{formatValue(data.netInterestIncome)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.netInterestIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.groupProfitLoss.netInterestMargin' default='Net Interest Margin %' /></Column1>
                  <Column2><Text medium colour={theme.colours.blue}>{formatPercentage(data.netInterestMargin)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.netInterestMarginChange} changeUnit='bps' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.otherBankingIncome' default='Other Banking Income' /></Column1>
                  <Column2><Text>{formatValue(data.otherBankingIncome)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.otherBankingIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                {fundsMgmtIncomeEnabled && (
                  <Row height={rowHeight}>
                    <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.fundsIncome' default='Funds Management Income' /></Column1>
                    <Column2><Text>{formatValue(data.fundsMgmtIncome)}</Text></Column2>
                    <Column3><ValueChangeText removePlusSign value={data.fundsMgmtIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                  </Row>
                )}
              </TableSection>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' bold uppercase value='ourFinancials.groupProfitLoss.totalIncome' default='TOTAL INCOME' /></Column1>
                  <Column2><Text bold>{formatValue(data.totalIncome)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign bold value={data.totalIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                {investmentExperienceEnabled && (
                  <Row height={rowHeight}>
                    <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.investmentExperience' default='Investment Experience' /></Column1>
                    <Column2><Text>{formatValue(data.investmentExperience)}</Text></Column2>
                    <Column3><ValueChangeText removePlusSign value={data.investmentExperienceChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                  </Row>
                )}
              </TableSection>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' bold uppercase value='ourFinancials.groupProfitLoss.totalOperatingIncome' default='TOTAL OPERATING INCOME' /></Column1>
                  <Column2><Text bold>{formatValue(data.totalOperatingIncome)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign bold value={data.totalOperatingIncomeChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.operatingExpenses' default='Operating Expenses' /></Column1>
                  <Column2><Text>{formatValue(data.opex)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.opexChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                </Row>
                {specialProjectsEnabled && (
                  <Row height={rowHeight}>
                    <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.specialProjects' default='Special Projects' /></Column1>
                    <Column2><Text>{formatValue(data.specialProjects)}</Text></Column2>
                    <Column3><ValueChangeText removePlusSign value={data.specialProjectsChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                  </Row>
                )}
              </TableSection>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' bold uppercase value='ourFinancials.groupProfitLoss.totalOperatingExpenses' default='TOTAL OPERATING EXPENSES' /></Column1>
                  <Column2><Text bold>{formatValue(data.totalOperatingExpenses)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign bold value={data.totalOperatingExpensesChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.groupProfitLoss.costToIncomeRatio' default='Cost to Income Ratio' /></Column1>
                  <Column2><Text medium colour={theme.colours.blue}>{formatPercentage(data.costToIncomeRatio)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.costToIncomeRatioChange} isCost changeUnit='bps' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.loanImpairmentExpense' default='Loan Impairment Expense' /></Column1>
                  <Column2><Text>{formatValue(data.lie)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.lieChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.groupProfitLoss.loanImpairmentRatio' default='Loan Impairment Expense %' /></Column1>
                  <Column2 style={borderHack}><Text medium colour={theme.colours.blue}>{formatPercentage(data.liePercentage)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.liePercentageChange} isCost changeUnit='bps' dashIfZero /></Column3>
                </Row>
              </TableSection>
              <TableSection>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' uppercase value='ourFinancials.groupProfitLoss.netProfitBeforeTax' default='NET PROFIT BEFORE TAX' /></Column1>
                  <Column2><Text>{formatValue(data.netProfitBeforeTax)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.netProfitBeforeTaxChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
                <Row height={rowHeight}>
                  <Column1><TranslatedText size='s' value='ourFinancials.groupProfitLoss.taxExpense' default='Tax Expense' /></Column1>
                  <Column2><Text>{formatValue(data.tax)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign value={data.taxChange} dp={1} isCost changeUnit='%' dashIfZero /></Column3>
                </Row>
              </TableSection>
              <TableSection>
                <Row
                  style={{
                    ...borderHack,
                    backgroundColor: '#eeeeee',
                    borderRightColor: theme.colours.bordergrey,
                    borderRightWidth: 0.5
                  }} height={rowHeight}
                >
                  <Column1><TranslatedText size='s' uppercase bold value='ourFinancials.groupProfitLoss.netProfitAfterTax' default='NET PROFIT AFTER TAX' /></Column1>
                  <Column2 style={{ backgroundColor: '#eeeeee' }}><Text bold>{formatValue(data.netProfitAfterTax)}</Text></Column2>
                  <Column3><ValueChangeText removePlusSign bold value={data.netProfitAfterTaxChange} dp={1} changeUnit='%' dashIfZero /></Column3>
                </Row>
              </TableSection>
            </>) : <CenteredSpinner />}
        </Table>
        <WidgetArea>
          <WidgetHeader>
            <Row height={2 * rowHeight}>
              <TranslatedText size='s' bold white center value='ourFinancials.groupProfitLoss.roeHeader' default={'Return On Equity\nby Division'} />
            </Row>
          </WidgetHeader>
          {loaded && divisions.map(d => {
            // return <Text key={d.typ}>{d.businessName}</Text>
            return (
              <ROEItemContainer key={d.type}>
                <ROEItem item={d} />
              </ROEItemContainer>
            )
          })}
        </WidgetArea>
      </Container>
    )
  }
}

export default LoadAfterDelay(FinancialGroupProfitAndLoss, { delay: 100 })
